import { Link } from "react-router-dom";
import { useTitle } from "@/core/context/TitleContext";
import { cloneElement, isValidElement, ReactElement, useEffect } from "react";
import { menuItems } from "@/core/config/menuConfig";

export const HomePage = () => {
    const { setTitle } = useTitle();
    useEffect(() => {
        setTitle("Front de inversiones");
    }, []);

    return (
        <div className="w-full py-10 px-4 md:px-10">
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
                {menuItems.map(menuItem => {
                    return menuItem.children?.map(({ label: title, description, icon, path: to }) => {
                        return description && to &&
                            (
                                <Link
                                    key={to}
                                    to={to}
                                    className="flex flex-col items-start bg-white dark:bg-secondary-800 p-6 rounded-lg shadow-neumorph transition hover:shadow-lg hover:-translate-y-1"
                                >
                                    <div className="w-full flex justify-center mb-4">
                                        {isValidElement(icon)
                                            ? cloneElement(icon as ReactElement, { className: "w-14 h-14 text-primary-500" })
                                            : icon}                                 </div>
                                    <h2 className="text-md font-medium mb-1">{title}</h2>
                                    <p className="text-sm text-gray-600 dark:text-gray-400">{description}</p>
                                </Link>
                            )
                    })
                })}
            </div>
        </div>
    );
};
